import React from "react";
import Headline from "./Headline";
import ContactAgents from "../../components/shared/ContactAgents";
import HomeLink from "../../widgets/HomeLink";
import { Col, Form, notification, Select } from "antd";
import B2C2BApi from "../../api-services/b2c2b-api.service";

const bannerPath = '/iceholidays-assets/images/contact_us_gd_cover.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'Contact Agents' }
] 

class ContactAgentsPage extends React.Component {

  state = {
    fairs: []
  }

  componentDidMount(): void {
    B2C2BApi.getFairs().then((fairsData) => {
      this.setState({ fairs: fairsData });
    }).catch(error => {
      notification.error({ message: 'An error occured while loading fairs.'});
    });
  }
  

  render(){
    const { fairs } = this.state;
    return (
      <div id="contact-agents-page" className="more-page">
        <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs} title="Contact Agents"/>

        <ContactAgents 
          type={["Series", "Flight", "Visa"]} 
          additionalFilters={
            <>
              <Col span={24}>
                <Form.Item label="Select Fair" name="fair">
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
                    }
                    placeholder="Please select"
                    options={fairs.map(({code}) => ({label: code, value: code}))}
                  />
                </Form.Item>
              </Col>
            </>
          }/>
      </div>
    )
  }
}

export default ContactAgentsPage;